module.exports = __webpack_public_path__ + "img/ganhe_tempo_icon.0d897d07.svg";